import React from 'react';
import InfoPage, { Section } from '../components/InfoPage';
import { Leaf } from 'lucide-react';

const herbs = [
  { name: 'Biota Orientalis', role: 'Soothes inflammation, supports follicle health.' },
  { name: 'Polygonum Multiflorum (He Shou Wu)', role: 'Traditional Korean herb for hair vitality and pigment.' },
  { name: 'Panax Ginseng', role: 'Stimulates blood circulation at the scalp.' },
  { name: 'Ganoderma (Reishi) Mushroom', role: 'Calms reactive scalps and balances oil.' },
  { name: 'Sophora Flavescens', role: 'Antimicrobial, helps reset the scalp microbiome.' },
  { name: 'Angelica Sinensis', role: 'Strengthens the hair shaft from the root.' },
  { name: 'Morus Alba (Mulberry) Root', role: 'Reduces shedding tied to stress and hormones.' },
  { name: 'Lycium Chinense (Goji)', role: 'Antioxidant-rich — protects against scalp aging.' },
  { name: 'Isatis Tinctoria', role: 'Cooling, supports inflamed and itchy scalps.' },
  { name: 'Vitex Trifolia', role: 'Balances scalp pH for healthier growth.' },
  { name: 'Dendrobium Officinale', role: 'Hydrates dry scalps without weighing hair down.' },
  { name: 'Rosmarinus Officinalis (Rosemary)', role: 'Classic scalp stimulant — wakes up sleepy follicles.' },
];

const freeFrom = ['Sulfates', 'Parabens', 'Silicones', 'Phthalates', 'Mineral oil', 'Artificial colors', 'Animal testing'];

const Ingredients = () => (
  <InfoPage
    title="Ingredients"
    subtitle="12 fermented Korean herbs. Zero filler. If we can't pronounce it, it's not in the bar."
  >
    <Section heading="The 12 herbs">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {herbs.map((h) => (
          <div key={h.name} className="p-4 rounded-2xl" style={{ backgroundColor: '#F5EDE0' }}>
            <div className="flex items-center gap-2 mb-1">
              <Leaf size={16} color="#2D5A3D" />
              <p className="text-[15px] font-semibold" style={{ color: '#2C2418' }}>{h.name}</p>
            </div>
            <p className="text-[13px] opacity-85" style={{ color: '#2C2418' }}>{h.role}</p>
          </div>
        ))}
      </div>
    </Section>

    <Section heading="Always free from">
      <div className="flex flex-wrap gap-2">
        {freeFrom.map((f) => (
          <span
            key={f}
            className="text-[12px] px-3 py-1.5 rounded-full"
            style={{ backgroundColor: '#2D5A3D', color: '#F5EDDF' }}
          >
            {f}
          </span>
        ))}
      </div>
    </Section>

    <Section heading="Full ingredient list (INCI)">
      <p className="text-[13px] opacity-90">
        Biota Orientalis Leaf Extract, Isatis Tinctoria Root Extract, Dendrobium Officinale Extract, Polygonum Multiflorum Extract,
        Angelica Sinensis Extract, Ganoderma Atrum Extract, Sophora Flavescens Extract, Sesamum Indicum Extract, Lycium Chinense Fruit Extract,
        Morus Alba Fruit Extract, Panax Ginseng Extract, Morus Alba Root Bark Extract, Vitex Trifolia Fruit Extract, Rosmarinus Officinalis Leaf Oil,
        Mentha Haplocalyx Extract, Cocos Nucifera Oil, Vitis Vinifera Seed Oil, Olea Europaea Fruit Oil, Butyrospermum Parkii Butter,
        Simmondsia Chinensis Seed Oil, Macadamia Ternifolia Seed Oil, Caprylic/Capric Triglyceride, Zingiber Officinale Root Oil,
        Melaleuca Alternifolia Leaf Oil, Boswellia Carterii Oil, Cedrus Atlantica Bark Oil, Cymbopogon Citratus Leaf Oil,
        Butylene Glycol, Glycyrrhiza Uralensis Extract, Rosmarinus Officinalis Extract, Taraxacum Mongolicum Extract,
        Paris Polyphylla Chinensis Extract, Isatis Indigotica Extract.
      </p>
    </Section>
  </InfoPage>
);

export default Ingredients;
